import React from 'react';

import PropTypes from 'prop-types';

import { emptyArray } from 'ui-components/default-props/empty';
import { useEntitiesReturnProperty } from '../../../../../../hooks/entities/selectors/returns';
import ReturnItemsTable from './return-items-table';

export const ReadOnlyReturnItemsTable = ({ returnFulfillmentId, containerWidth }) => {
  const items = useEntitiesReturnProperty(returnFulfillmentId, 'items') || emptyArray;

  return <ReturnItemsTable containerWidth={containerWidth} items={items} />;
};

ReadOnlyReturnItemsTable.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
  containerWidth: PropTypes.number.isRequired,
};
